module.exports = __webpack_public_path__ + "img/pht.3335aaba.png";